module.exports = __webpack_public_path__ + "media/Text_headline_+_1x1.2fbc4089.mp4";